<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'EnterpriseCulture'
}
</script>

<style lang="scss"></style>
